import { useNavigate, useParams } from "react-router-dom";
import AdminOnly from "#/components/auth/AdminOnly";
import Typography from "#/components/shared/typography";
import { ActionButton } from "#/components/shared/buttons/ActionButtons";
import MedicalConceptDetail from "#/admin/medical-concepts/components/MedicalConceptDetail";

export default function AdminMedicalConceptDetailPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <AdminOnly>
        <div className="container mx-auto px-4 py-6">
          <Typography variant="h4" className="text-terracotta">
            Medical concept not found
          </Typography>
        </div>
      </AdminOnly>
    );
  }

  return (
    <AdminOnly>
      <div className="container mx-auto flex flex-col gap-6 px-4 py-6">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex flex-col gap-1">
            <Typography variant="caption" className="text-brown-500">
              Medical concepts / details
            </Typography>
            <Typography variant="h2" className="text-brown-900">
              Medical concept details
            </Typography>
            <Typography variant="body2" className="text-brown-600">
              Manage concept-specific generation workflows and related suggestions.
            </Typography>
          </div>

          <ActionButton
            tone="secondary"
            onClick={() => navigate("/admin/content/medical-concepts")}
          >
            Back to concepts
          </ActionButton>
        </div>

        <MedicalConceptDetail id={id} />
      </div>
    </AdminOnly>
  );
}
